import Actions             from 'Redux/Actions';
import { AppUserRepository } from 'Domain/Repositories';
import { ofType }          from 'redux-observable';
import { from, EMPTY }     from 'rxjs';
import { mergeMap }        from 'rxjs/operators';
import { TEpic }           from 'Redux/Config';

export const findAppUserEpic: TEpic = (action$) => {
  return action$.pipe(
    ofType(Actions.findAppUserRequest.type),
    mergeMap(action => {
      const { id } = action.payload;

      if (!id.trim()) {
        return EMPTY;
      }

      return from(
        AppUserRepository.findById(id)
          .then((appUser) => Actions.findAppUserSuccess({ appUser }))
          .catch(error => Actions.findAppUserFailure({ error })),
      );
    }),
  );
};
